<form [formGroup]="overlayAnalysisForm" (ngSubmit)="onSubmit()">
    <div class="parent-div">
        <div class="child-div">
            <mat-form-field>
                <mat-label>{{ 'OVERLAY-ANALYSIS-DIALOG.ANALYSIS-TYPE' | translate }}</mat-label>

                <mat-select formControlName="analysis" required>
                    <mat-option value="ndvi">{{ 'OVERLAY-ANALYSIS-DIALOG.NDVI' | translate }}</mat-option>
                    <mat-option value="ni">{{ 'OVERLAY-ANALYSIS-DIALOG.NI' | translate }}</mat-option>
                </mat-select>

<!--                <select matNativeControl formControlName="analysis" required>-->
<!--                    <option value="ndvi">{{ 'OVERLAY-ANALYSIS-DIALOG.NDVI' | translate }}</option>-->
<!--                    <option value="ni">{{ 'OVERLAY-ANALYSIS-DIALOG.NI' | translate }}</option>-->
<!--                    </select>-->
            </mat-form-field>
        </div>
        <div class="child-div">
            <mat-form-field>
                <mat-label>{{ 'OVERLAY-ANALYSIS-DIALOG.DATE' | translate }}</mat-label>
                <input readonly matInput [matDatepicker]="picker"  [max]="maxDate" formControlName="date"
                    (dateInput)="dateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
        <button  class="overlay-btn" mat-button [mat-dialog-close]="true" type="submit" cdkFocusInitial>{{
            'OVERLAY-ALL-DIALOG.OVERLAY' | translate }}</button>
    </mat-dialog-actions>
</form>
